const addOrReplace = (arr, findFn, newValue) => {
  const currentValue = arr.find(findFn);
  return currentValue ? arr.map(i => findFn(i) ? newValue : i) : [...arr, newValue];
};
export default addOrReplace;